import { z } from 'zod'

import ZBaseAction from './base'

const ZReplayQuestionAction = ZBaseAction.extend({
  replayQuestion: z.object({}),
})

export default ZReplayQuestionAction
